<template>
  <section class="testimonials py-5 bg-light text-center">
    <div class="container">
      <h2 class="mb-4">What Our Clients Say</h2>
      <div class="row">
        <div class="col-md-4 mb-4" v-for="(t, index) in testimonials" :key="index">
          <blockquote class="blockquote">
            <p class="mb-2">"{{ t.quote }}"</p>
            <footer class="blockquote-footer">{{ t.name }}</footer>
          </blockquote>
        </div>
      </div>
    </div>
  </section>
  
  </template>
  
  <script setup>
  
  
  const testimonials = [
    {
      quote: "Their POS system streamlined our entire operation—fast, intuitive, and reliable.",
      name: "Sarah L., Café Owner"
    },
    {
      quote: "Incredible customer support and a truly all-in-one payment solution.",
      name: "Tom B., Retail Manager"
    },
    {
      quote: "Our sales process is smoother than ever. Highly recommend to any small business.",
      name: "Aisha R., Boutique Owner"
    }
  ]
  
  </script>
  
  <style>
  
  .testimonials {
  background-color: #f8f9fa;
}

.blockquote {
  background: #ffffff;
  padding: 1.5rem;
  border-left: 4px solid var(--primary, #0d6efd);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  font-style: italic;
  height:180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.blockquote-footer {
  margin-top: 1rem;
  font-weight: 500;
  color: #6c757d;
}

  </style>